import React from "react";
import { ReactTableScroll } from 'react-table-scroll';

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Table,
  Container,
  Row,
  Col,
} from "react-bootstrap";

import { useTranslation } from 'react-i18next';

//import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";


function AdjustmentsEditTable({adjustmentSchedule, scheduleDetails, onRecordDelete, onChangeOrder}) {
  const {t, i18n} = useTranslation();

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <h5>Adjustments</h5>
            
            <Card>
              <Card.Body>
                <div style={{maxHeight: "35vh", overflow: "auto"}}>
                  <Table className="table-hover table-striped w-full">
                  <thead>
                    <tr>
                      <th>Change Order</th>
                      <th>Sequence</th>
                      <th>Code</th>
                      <th>Description</th>
                      <th>Free Goods?</th>
                      <th>Bundle?</th>
                      <th>Optional Code</th>
                      {/* <th>By Customer Type?</th> */}
                      <th>Delete</th>
                    </tr>
                  </thead>

                  <tbody>
                    { adjustmentSchedule.scheduleDetails && 
                      adjustmentSchedule.scheduleDetails.map((adj, i) => (
                      <tr key={i}>
                        <td style={{position: "relative"}}>
                          <Button
                            onClick={(event) => onChangeOrder(event, adj.adjustment.code, "up")}
                            size="sm"
                            className="btn-link remove"
                            name="adjustmentOrder"
                            value={adj.code}
                          >
                            <i className="far fa-angle-up"/>
                          </Button>
                          <Button
                            onClick={(event) => onChangeOrder(event, adj.adjustment.code, "down")}
                            size="sm"
                            className="btn-link remove"
                            name="adjustmentOrder"
                            value={adj.code}
                          >
                            <i className="far fa-angle-down"/>
                          </Button>
                        </td>
                        <td>{i+1}</td>
                        <td>{adj.adjustment.code}</td>
                        <td>{adj.adjustment.description}</td>
                        <td>{adj.adjustment.freeGoods === true ? "Yes" : "No"}</td>
                        <td>{adj.adjustment.bundle === true    ? "Yes" : "No"}</td>
                        <td>{adj.adjustment.optionalCode}</td>
                        {/* <td>{adj.adjustment.byCustomerType? "Yes" : "No"}</td> */}
                        <td>
                          <Button
                            onClick={(event) => onRecordDelete({name: "adjustmentDelete", value: adj.adjustment.code})}
                            variant="danger"
                            size="sm"
                            className="btn-link remove text-danger"
                            name="adjustmentDelete"
                            value={adj.code}
                          >
                            <i className="fa fa-times" />
                          </Button>

                        </td>
                      </tr>
                    ))}
                  </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

      </Container>
    </>
  );
}

export default AdjustmentsEditTable;
